import { defaultLanguage } from './../../constant';
import { Component, OnInit , AfterViewInit, OnDestroy} from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';

import { CookieManagerService, ErrorManagerService, HttpClientService, PipeTransformPipe } from '../../../shared/';
import { TranslateService } from '@ngx-translate/core';

import { ApiEndpoints } from '../../constant';
import swal from 'sweetalert2';

@Component({
  selector: 'app-instructions',
  templateUrl: '../views/instructions.component.html',
  styleUrls: ['../../../css/instructions.component.css', '../../../css/paper-sets.component.css', '../../setting/setting.component.css']
})
export class InstructionsComponent implements OnInit {
  public playList: Array<any> = [];
  public tipsList: Array<any> = [];
  public PlayListData: any;
  public videoUrl: string;
  public title: string;
  public language = defaultLanguage;
  constructor(
    private translateService: TranslateService,
    private HttpClientService: HttpClientService,
    private sanitizer: DomSanitizer,
    private router: Router,
    private ErrorManagerService: ErrorManagerService,
    private cookieManagerService: CookieManagerService
  ) { }

  ngOnInit() {
    document.body.scrollTop = 0;
    this.setClass();

    var value =  this.cookieManagerService.getCookie("Lang", false);
    this.language = value ? value : defaultLanguage;
    
  }

  ngAfterViewInit(){
    this.getTipList();
  }

  setYoutubePlayList() {
    if(this.playList.length != 0){
      return;
    }
    this.HttpClientService.getYoutube(ApiEndpoints.adviceList).subscribe(response => {
      response.items.forEach(item => {
        this.playList.push(
          {
            'videoUrl': ApiEndpoints.YOUTUBE_BASE_URL + item.snippet.resourceId.videoId,
            'title': item.snippet.title,
            'description': item.snippet.description,
            'thumbnails': item.snippet.thumbnails.medium.url
          });
      });
    },
      error => {
        this.ErrorManagerService.setError(error);
      }
    );
  }

  getTipList() {
    if(this.tipsList.length != 0){
      return;
    }
    this.HttpClientService.get(ApiEndpoints.tipList).subscribe(response => {
      response.items.forEach(item => {
        this.tipsList.push(
          {
            'videoUrl': ApiEndpoints.YOUTUBE_BASE_URL + item.snippet.resourceId.videoId,
            'title': item.snippet.title,
            'description': item.snippet.description,
            'thumbnails': item.snippet.thumbnails.medium.url
          });
      });
    },
      error => {
        this.ErrorManagerService.setError(error);
      }
    );
  }

  viewVideo(videoUrl, title) {
    this.title = title;
    this.videoUrl = videoUrl;
  }

  ngOnDestroy(){
    this.title = '';
    this.videoUrl = '';
  }

  modalClose(){
    this.videoUrl = '';
  }

  setClass(){
    if(this.router.url == '/help'){
      document.getElementById('instruction').className = 'instruction-landing';
    }
  }
}



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/instructions/components/instructions.component.ts